import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Content from "./content";
import "./Dashboard.css";

const CompanyDashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Toggle sidebar when hamburger is clicked
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // When a sidebar item is clicked, close the sidebar (for mobile)
  const handleSidebarItemClick = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className="dashboard-container">
      {/* Sidebar: pass open state and callback */}
      <Sidebar isOpen={isSidebarOpen} onItemClick={handleSidebarItemClick} />

      {/* Main content area */}
      <div className="dashboard-main-content">
        {/* Top bar with hamburger – visible on small screens */}
        <div className="dashboard-topbar">
          <button className="dashboard-hamburger" onClick={toggleSidebar}>
            &#9776;
          </button>
        </div>
        {/* Content (routed child components) */}
        <Content />
      </div>
    </div>
  );
};

export default CompanyDashboard;
